
// import './bootstrap';
import lottie from 'lottie-web';
import './lazyload';
import './web-vitals';

import AsyncAlpine from 'async-alpine';
import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
AsyncAlpine.init(Alpine);
AsyncAlpine.start();
Livewire.start();

import ResizeObserver from 'resize-observer-polyfill';
import AOS from 'aos';
import 'aos/dist/aos.css';

import 'smoothscroll-polyfill/dist/smoothscroll.min.js';
window.ResizeObserver = ResizeObserver;
AOS.init();

//Smooth scroll anchors
document.addEventListener('DOMContentLoaded', function () {
    const anchors = document.querySelectorAll('a[href^="#"]');
    const header = document.querySelector('#header');

    anchors.forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = anchor.getAttribute('href');
            if (targetId === '#') return;

            const targetElement = document.querySelector(targetId);

            if (targetElement && header) {
                const headerHeight = header.offsetHeight;
                const startPosition = window.scrollY;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const finalPosition = targetPosition - headerHeight;
                let startTime = null;
                const duration = 1000; // Duration in milliseconds

                function scrollAnimation(currentTime) {
                    if (startTime === null) startTime = currentTime;
                    const timeElapsed = currentTime - startTime;
                    const run = easeInOutCubic(timeElapsed, startPosition, finalPosition - startPosition, duration);

                    window.scrollTo(0, run);

                    if (timeElapsed < duration) requestAnimationFrame(scrollAnimation);
                }

                function easeInOutCubic(t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) return (c / 2) * t * t * t + b;
                    t -= 2;
                    return (c / 2) * (t * t * t + 2) + b;
                }

                requestAnimationFrame(scrollAnimation);
            }
        });
    });

    const lottieElements = document.querySelectorAll('.lottie');

    lottieElements.forEach((el) => {
        const path = el.getAttribute('data-path');
        if (path) {
            lottie.loadAnimation({
                container: el,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: path,
            });
        }
    });
});
